/**
 * Waits for all images within a carousel to load.
 * @param {HTMLElement} carousel - The Flickity carousel element.
 * @returns {Promise} - Resolves when all images are loaded or have errored.
 */
function waitForImagesToLoad(carousel) {
  const images = carousel.querySelectorAll('img');
  const imagePromises = Array.from(images).map(img => {
    if (img.complete && img.naturalHeight !== 0) {
      // Image is already loaded
      return Promise.resolve();
    } else {
      // Return a promise that resolves when the image loads or errors
      return new Promise(resolve => {
        img.addEventListener('load', resolve);
        img.addEventListener('error', resolve);
      });
    }
  });
  return Promise.all(imagePromises);
}

document.addEventListener('DOMContentLoaded', function () {
  // Select all Flickity carousels on the page
  const carousels = document.querySelectorAll('.flickity-carousel');

  carousels.forEach(function (carousel) {
    // Wait for all images within the carousel to load
    waitForImagesToLoad(carousel).then(() => {
      // Prevent Flickity from initializing multiple times on the same carousel
      if (carousel.flickity) {
        console.warn('Flickity is already initialized on this carousel:', carousel);
        return;
      }

      console.log('Initializing Flickity on carousel:', carousel);

      // Initialize Flickity with desired options
      const flkty = new Flickity(carousel, {
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false, // Disable Flickity's default buttons
        cellAlign: 'left',      // Align cells to the left; adjust as needed
        contain: true,          // Contain cells within the carousel container
        // Optional: adaptiveHeight: true, // Uncomment if you want the carousel height to adjust based on the selected cell
      });

      // Handle custom navigation buttons
      const parentContainer = carousel.parentElement;
      const prevButton = parentContainer.querySelector('.flickity-prev');
      const nextButton = parentContainer.querySelector('.flickity-next');

      if (prevButton && nextButton) {
        // Ensure buttons are accessible
        prevButton.setAttribute('role', 'button');
        nextButton.setAttribute('role', 'button');
        prevButton.setAttribute('tabindex', '0');
        nextButton.setAttribute('tabindex', '0');

        // Attach click event listeners to custom buttons
        prevButton.addEventListener('click', function () {
          flkty.previous();
        });

        nextButton.addEventListener('click', function () {
          flkty.next();
        });

        // Add keyboard accessibility (Enter and Space keys)
        [prevButton, nextButton].forEach(function (button) {
          button.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              button.click();
            }
          });
        });
      }

      // Ensure Flickity recalculates layout after initialization
      flkty.resize();

      console.log('Flickity initialized:', flkty);
    }).catch((error) => {
      console.error('Error loading images in carousel:', carousel, error);
    });
  });

  // Handle animation play state for collection sliders
  const sliders = document.querySelectorAll('.collection-slider');

  sliders.forEach(slider => {
    slider.addEventListener('mouseenter', () => {
      slider.style.animationPlayState = 'paused';
    });

    slider.addEventListener('mouseleave', () => {
      slider.style.animationPlayState = 'running';
    });
  });
});
